import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';

const tags = {
  getQRApplications: 'getQRApplications',
  approve: 'approve',
};

export const QRApplicationsApi = createApi({
  reducerPath: 'QRApplicationsApi',
  tagTypes: [tags.getQRApplications, tags.getQRApplication],
  endpoints: (builder) => ({
    approve: builder.mutation({
      query: ({ userPK, orderId, amount, status }) => {
        const body = {
          'user_pk': userPK,
          'order_id': orderId,
          'amount': amount,
          status: status,
        };
        return ({
          method: 'post', url: `/m-pay/order-confirm`,
          body: body,
        });
      },
      providesTags: [tags.approve],
      invalidatesTags: [tags.getQRApplications],
    }),
    getQRApplications: builder.query({
      query: (queryParams) => {
        const [page, limit, status, search] = queryParams;

        const params = {
          page_number: page,
          page_size: limit,
        };

        if (status) {
          params.status = status;
        }

        if (search) {
          params.search_value = search;
        }

        return ({
          method: 'get', url: `/m-pay/order-get?${serialize(params)}`,
        });
      },
      providesTags: [tags.getQRApplications],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
      transformResponse: (data) => {
        return {
          list: data.order_list,
          count: data.page_amount,
        };
      },
    }),
  }),
});

export const QRApplicationsParams = createSlice({
  name: 'QRApplicationsParams',
  initialState: {
    page: 1,
    limit: 100,
    status: 'PENDING'
  },
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },

  },
});
export const {
  useGetQRApplicationsQuery,
  useApproveMutation,
} = QRApplicationsApi;

export const { setParams } = QRApplicationsParams.actions;
export const QRApplicationsParamsReducer = QRApplicationsParams.reducer;
export const QRApplicationsParamsSelector = (state) => state.QRApplicationsParams;